<template>
  <section class="installation section" id="installation">
    <div class="shell">
      <div class="section-top">
        <div>
          <span class="eyebrow light-eyebrow">УСТАНОВКА БЕЗ ЛИШНИХ ЗАБОТ</span>
          <h2>От первого разговора<br />до первого кадра</h2>
        </div>
        <p class="section-intro">
          Берём на себя техническую часть.<br />Вам остаётся только наблюдать
        </p>
      </div>
      <div class="steps">
        <article>
          <h3>Знакомимся с задачей</h3>
          <p>Уточняем зоны наблюдения, условия на объекте и нужную глубину архива.</p>
        </article>
        <article>
          <h3>Собираем решение</h3>
          <p>Подбираем оборудование, планируем размещение и согласуем подробную смету.</p>
        </article>
        <article>
          <h3>Устанавливаем</h3>
          <p>Прокладываем кабель, подключаем камеры, проверяем запись и удалённый доступ.</p>
        </article>
        <article>
          <h3>Передаём вам</h3>
          <p>Показываем, как смотреть камеры, находить события и сохранять фрагменты.</p>
        </article>
      </div>
    </div>
  </section>
</template>
